import '@d3fc/d3fc-element';

import { line } from 'utils/components/TimeSeriesChart/line';
import { area } from 'utils/components/TimeSeriesChart/area';
import { SignalChartTimeSeriesItem } from 'widgets/signalTiles/signalTile/components/chart/signalTileData';

const aboveLine = line<SignalChartTimeSeriesItem>((d) => d.above, 'above-line');

const aboveArea = (upperBoundary: number) =>
    area<SignalChartTimeSeriesItem>(
        (d) => d.above,
        'above-area',
        undefined,
        () => upperBoundary
    );

export const aboveSeries = (upperBoundary: number) => [
    aboveLine,
    aboveArea(upperBoundary),
];
